
import React from 'react';

interface DealMapProps {
  address: string;
  businessName: string;
}

export default function DealMap({ address, businessName }: DealMapProps) {
  const query = encodeURIComponent(`${businessName}, ${address}`);

  return (
    <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
      <div className="p-5 pb-3">
        <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-map-pin-2-line text-teal-600 text-base"></i>
          </div>
          Location
        </h2>
      </div>

      <div className="relative w-full h-[280px]">
        <iframe
          title={`Map showing ${businessName} location`}
          src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${query}&zoom=15`}
          className="w-full h-full border-0"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      <div className="p-4 flex items-center justify-between">
        <p className="text-xs text-gray-500">{address}</p>
        <a
          href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
            address
          )}`}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="text-xs text-teal-600 font-semibold hover:text-teal-700 flex items-center gap-1 cursor-pointer whitespace-nowrap"
        >
          Open in Maps
          <i className="ri-external-link-line text-xs"></i>
        </a>
      </div>
    </div>
  );
}
